/**
 * Layout A + C, fase 2 (Integrações, Admin, Agentes, Ajuda): textos novos das telas migradas — indicadores, facetas,
 * visões, rodapé de status e comandos do Ctrl K. Inglês é a fonte; pt-BR e es têm as mesmas chaves.
 */
const en = {
  'lac.filters': 'Filters',
  'lac.kpis': 'Indicators',
  'lac.view': 'View',
  'lac.view.cards': 'Cards',
  'lac.view.table': 'List',
  'lac.quick': 'Quick filters',
  'lac.all': 'All',

  'lac.integ.kpi.total': 'In the catalog',
  'lac.integ.kpi.connected': 'Connected',
  'lac.integ.kpi.attention': 'Need attention',
  'lac.integ.kpi.error': 'With error',
  'lac.integ.kpi.available': 'Available to connect',
  'lac.integ.col.name': 'Integration',
  'lac.integ.col.connection': 'Connection',
  'lac.integ.col.lastSync': 'Last sync',
  'lac.integ.status.inUse.one': '{count} integration in use',
  'lac.integ.status.inUse.other': '{count} integrations in use',
  'lac.integ.status.problems.one': '{count} connection with a problem',
  'lac.integ.status.problems.other': '{count} connections with a problem',
  'lac.integ.status.healthy': 'connections healthy',
  'lac.integ.status.sync': 'last sync',
  'lac.integ.status.what': 'connections',
  'lac.integ.cmd.health': 'Open connection health',
  'lac.integ.cmd.connect': 'Connect an integration',
  'lac.integ.cmd.connectWord': 'connect',
  'lac.integ.cmd.connectHint': 'connect <integration>',
  'lac.integ.cmd.connectOne': 'Connect {name}',
  'lac.integ.cmd.openOne': 'Open the {name} connection',
  'lac.integ.cmd.apiDocs': 'Open the API documentation',
  'lac.noMatch': 'Nothing matches these filters.',
  'lac.secc.kind': 'Type',
  'lac.secc.category': 'Category',
  'lac.secc.kpi.total': 'Connectors',
  'lac.secc.kpi.ok': 'Read OK',
  'lac.secc.kpi.running': 'Reading now',
  'lac.secc.kpi.error': 'With error',
  'lac.secc.kpi.findings': 'Findings read',
  'lac.secc.col.assets': 'Assets',
  'lac.secc.col.error': 'Last error',
  'lac.secc.status.count.one': '{count} security connector',
  'lac.secc.status.count.other': '{count} security connectors',
  'lac.secc.status.errors.one': '{count} with error',
  'lac.secc.status.errors.other': '{count} with error',
  'lac.secc.status.running.one': '{count} reading now',
  'lac.secc.status.running.other': '{count} reading now',
  'lac.secc.status.what': 'last read',
  'lac.secc.cmd.findings': 'Open merged findings',
  'lac.clearFilters': 'Clear filters',
  'lac.agents.status.updateFailed.one': '{count} agent with a failed update',
  'lac.agents.status.updateFailed.other': '{count} agents with a failed update',
  'lac.agents.status.what': 'agents',
  'lac.agents.cmd.updates': 'Open agent updates and rings',
  'lac.agents.cmd.find': 'Find an agent',
  'lac.agents.cmd.findWord': 'agent',
  'lac.agents.cmd.findHint': 'agent <machine name>',
  'lac.agents.cmd.findOne': 'Find agent "{name}"',
  'lac.agents.kpi.lateOffline': 'Late or offline',
  'lac.agents.kpi.updateFailed': 'Failed update',
  'lac.agents.facet.reason': 'Update failure reason',
  'lac.agents.col.lastError': 'Last error',
  'lac.agents.chip.all': 'All',
  'lac.agents.chip.problems': 'With a problem',
  'lac.agents.chip.updateFailed': 'Failed update',
  'lac.agents.chip.collectors': 'Collectors',
  'lac.agents.chip.quarantined': 'In quarantine',
  'lac.agents.revokeMany.one': 'Revoke {count} agent?',
  'lac.agents.revokeMany.other': 'Revoke {count} agents?',
  'lac.agents.revokedMany.one': '{count} agent revoked',
  'lac.agents.revokedMany.other': '{count} agents revoked',
  'lac.agents.retriedMany.one': 'Update will be retried on {count} agent',
  'lac.agents.retriedMany.other': 'Update will be retried on {count} agents',
  'lac.agents.retryCount.one': 'Try the update again ({count})',
  'lac.agents.retryCount.other': 'Try the update again ({count})',
  'lac.agents.revokeCount.one': 'Revoke ({count})',
  'lac.agents.revokeCount.other': 'Revoke ({count})',
  'lac.upd.kpi.active': 'Rollouts in progress',
  'lac.upd.kpi.failed': 'Agents that failed',
  'lac.upd.notes': 'Notes',
  'lac.upd.stage': 'Stage',
  'lac.upd.result': 'Result',
  'lac.upd.os': 'System',
  'lac.upd.targeted': 'Targeted',
  'lac.upd.updated': 'Updated',
  'lac.users.status.active.one': '{count} active person',
  'lac.users.status.active.other': '{count} active people',
  'lac.users.status.pending.one': '{count} waiting for access',
  'lac.users.status.pending.other': '{count} waiting for access',
  'lac.users.status.invited.one': '{count} invitation not accepted',
  'lac.users.status.invited.other': '{count} invitations not accepted',
  'lac.users.status.what': 'people',
  'lac.users.cmd.pending': 'See who is waiting for access',
  'lac.users.cmd.newProfile': 'Create an access profile',
  'lac.users.kpi.all': 'People',
  'lac.users.col.name': 'Name',
  'lac.users.col.email': 'Email',
  'lac.users.resentMany.one': 'Invitation sent again to {count} person',
  'lac.users.resentMany.other': 'Invitation sent again to {count} people',
  'lac.users.resendCount.one': 'Resend invitation ({count})',
  'lac.users.resendCount.other': 'Resend invitations ({count})',
  'lac.help.status.articles.one': '{count} article in the manual',
  'lac.help.status.articles.other': '{count} articles in the manual',
  'lac.help.cmd.pdf': 'Download the manual (PDF)',
  'lac.help.cmd.search': 'Search the manual',
  'lac.help.cmd.searchWord': 'manual',
  'lac.help.cmd.searchHint': 'manual <words>',
  'lac.help.cmd.searchOne': 'Search the manual for "{q}"',
  'lac.yes': 'Yes',
  'lac.no': 'No',
  'lac.ch.status.one': '{count} change in {days} days',
  'lac.ch.status.other': '{count} changes in {days} days',
  'lac.ch.what': 'history',
  'lac.ch.cmd.week': 'Configuration changes in the last 7 days',
  'lac.ch.cmd.year': 'Configuration changes in the last year',
  'lac.ch.col.when': 'When',
  'lac.ch.col.name': 'Item',
  'lac.ch.col.what': 'What happened',
  'lac.ch.col.author': 'Who',
  'lac.ch.col.version': 'Version',
  'lac.ch.view.timeline': 'Timeline',
  'lac.tpl.status.one': '{count} template · {available} available',
  'lac.tpl.status.other': '{count} templates · {available} available',
  'lac.tpl.cmd.use': 'Use a template',
  'lac.tpl.cmd.useWord': 'template',
  'lac.tpl.cmd.useHint': 'template <name>',
  'lac.tpl.cmd.useOne': 'Use the template "{name}"',
  'lac.tpl.col.title': 'Template',
  'lac.tpl.col.kind': 'Type',
  'lac.tpl.col.description': 'Description',
  'lac.tpl.col.available': 'Available',
  'lac.org.status.locations.one': '{count} place registered',
  'lac.org.status.locations.other': '{count} places registered',
  'lac.org.status.departments.one': '{count} department registered',
  'lac.org.status.departments.other': '{count} departments registered',
  'lac.org.cmd.map': 'Show the organization as a map',
  'lac.org.col.path': 'Path',
  'lac.org.col.code': 'Code',
  'lac.org.col.direct': 'Machines directly here',
  'lac.ai.status.recs.one': '{count} recommendation',
  'lac.ai.status.recs.other': '{count} recommendations',
  'lac.ai.status.critical.one': '{count} critical',
  'lac.ai.status.critical.other': '{count} critical',
  'lac.ai.status.lastRun': 'last analysis',
  'lac.ai.status.what': 'recommendations',
  'lac.ai.cmd.run': 'Run the analysis now ({kind})',
  'lac.ai.cmd.ask': 'Ask the AI',
  'lac.ai.col.title': 'Recommendation',
  'lac.ai.col.deadline': 'Deadline',
  'lac.ai.col.reason': 'Reason',
  'lac.ai.col.actor': 'Who ran it',
  'lac.ai.col.candidates': 'Candidates',
  'lac.aut.action': 'What it does',
  'lac.aut.action.ticket': 'Opens a ticket',
  'lac.aut.action.notify': 'Sends a notice',
  'lac.aut.on': 'Turned on',
  'lac.aut.off': 'Turned off',
  'lac.aut.kpi.rules': 'Rules',
  'lac.aut.kpi.opened': 'Tickets opened (24 h)',
  'lac.aut.kpi.notified': 'Notices sent (24 h)',
  'lac.aut.status.one': '{count} of {total} rule turned on',
  'lac.aut.status.other': '{count} of {total} rules turned on',
  'lac.aut.what': 'last run',
  'lac.aut.cmd.history': 'Open the automation history',
  'lac.aut.turnOn': 'Turn on',
  'lac.aut.turnOff': 'Turn off',
  'lac.aut.col.maxHour': 'Limit per hour',
  'lac.aut.col.maxDay': 'Limit per day',
  'lac.cred.kind': 'Type',
  'lac.cred.test': 'Last test',
  'lac.cred.kpi.all': 'Credentials',
  'lac.cred.status.one': '{count} credential in the vault',
  'lac.cred.status.other': '{count} credentials in the vault',
  'lac.cred.statusFail.one': '{count} failed the last test',
  'lac.cred.statusFail.other': '{count} failed the last test',
  'lac.cred.col.name': 'Name',
  'lac.cred.col.user': 'User',
  'lac.cred.col.port': 'Port',
  'lac.cred.col.scope': 'Where it is used',
  'lac.cred.col.scans': 'Scans',
  'lac.cred.col.testedAt': 'Tested at',
  'lac.me.status.mfaOn': 'second factor on',
  'lac.me.status.mfaOff': 'second factor off',
  'lac.me.status.sessions.one': '{count} open session',
  'lac.me.status.sessions.other': '{count} open sessions',
} as const;

type K = keyof typeof en;

const ptBR: Record<K, string> = {
  'lac.filters': 'Filtros',
  'lac.kpis': 'Indicadores',
  'lac.view': 'Visão',
  'lac.view.cards': 'Cartões',
  'lac.view.table': 'Lista',
  'lac.quick': 'Filtros rápidos',
  'lac.all': 'Todos',

  'lac.integ.kpi.total': 'No catálogo',
  'lac.integ.kpi.connected': 'Conectadas',
  'lac.integ.kpi.attention': 'Pedem atenção',
  'lac.integ.kpi.error': 'Com erro',
  'lac.integ.kpi.available': 'Disponíveis para conectar',
  'lac.integ.col.name': 'Integração',
  'lac.integ.col.connection': 'Conexão',
  'lac.integ.col.lastSync': 'Última sincronização',
  'lac.integ.status.inUse.one': '{count} integração em uso',
  'lac.integ.status.inUse.other': '{count} integrações em uso',
  'lac.integ.status.problems.one': '{count} conexão com problema',
  'lac.integ.status.problems.other': '{count} conexões com problema',
  'lac.integ.status.healthy': 'conexões saudáveis',
  'lac.integ.status.sync': 'última sincronização',
  'lac.integ.status.what': 'conexões',
  'lac.integ.cmd.health': 'Abrir a saúde das conexões',
  'lac.integ.cmd.connect': 'Conectar uma integração',
  'lac.integ.cmd.connectWord': 'conectar',
  'lac.integ.cmd.connectHint': 'conectar <integração>',
  'lac.integ.cmd.connectOne': 'Conectar {name}',
  'lac.integ.cmd.openOne': 'Abrir a conexão {name}',
  'lac.integ.cmd.apiDocs': 'Abrir a documentação da API',
  'lac.noMatch': 'Nada com esses filtros.',
  'lac.secc.kind': 'Tipo',
  'lac.secc.category': 'Categoria',
  'lac.secc.kpi.total': 'Conectores',
  'lac.secc.kpi.ok': 'Lidos sem erro',
  'lac.secc.kpi.running': 'Lendo agora',
  'lac.secc.kpi.error': 'Com erro',
  'lac.secc.kpi.findings': 'Achados lidos',
  'lac.secc.col.assets': 'Ativos',
  'lac.secc.col.error': 'Último erro',
  'lac.secc.status.count.one': '{count} conector de segurança',
  'lac.secc.status.count.other': '{count} conectores de segurança',
  'lac.secc.status.errors.one': '{count} com erro',
  'lac.secc.status.errors.other': '{count} com erro',
  'lac.secc.status.running.one': '{count} lendo agora',
  'lac.secc.status.running.other': '{count} lendo agora',
  'lac.secc.status.what': 'última leitura',
  'lac.secc.cmd.findings': 'Abrir os achados unidos',
  'lac.clearFilters': 'Limpar filtros',
  'lac.agents.status.updateFailed.one': '{count} agente com atualização falha',
  'lac.agents.status.updateFailed.other': '{count} agentes com atualização falha',
  'lac.agents.status.what': 'agentes',
  'lac.agents.cmd.updates': 'Abrir atualizações e anéis dos agentes',
  'lac.agents.cmd.find': 'Procurar um agente',
  'lac.agents.cmd.findWord': 'agente',
  'lac.agents.cmd.findHint': 'agente <nome da máquina>',
  'lac.agents.cmd.findOne': 'Procurar o agente "{name}"',
  'lac.agents.kpi.lateOffline': 'Atrasados ou desligados',
  'lac.agents.kpi.updateFailed': 'Atualização falhou',
  'lac.agents.facet.reason': 'Motivo da falha de atualização',
  'lac.agents.col.lastError': 'Último erro',
  'lac.agents.chip.all': 'Todos',
  'lac.agents.chip.problems': 'Com problema',
  'lac.agents.chip.updateFailed': 'Atualização falhou',
  'lac.agents.chip.collectors': 'Coletores',
  'lac.agents.chip.quarantined': 'Em quarentena',
  'lac.agents.revokeMany.one': 'Revogar {count} agente?',
  'lac.agents.revokeMany.other': 'Revogar {count} agentes?',
  'lac.agents.revokedMany.one': '{count} agente revogado',
  'lac.agents.revokedMany.other': '{count} agentes revogados',
  'lac.agents.retriedMany.one': 'A atualização será tentada de novo em {count} agente',
  'lac.agents.retriedMany.other': 'A atualização será tentada de novo em {count} agentes',
  'lac.agents.retryCount.one': 'Tentar a atualização de novo ({count})',
  'lac.agents.retryCount.other': 'Tentar a atualização de novo ({count})',
  'lac.agents.revokeCount.one': 'Revogar ({count})',
  'lac.agents.revokeCount.other': 'Revogar ({count})',
  'lac.upd.kpi.active': 'Distribuições em andamento',
  'lac.upd.kpi.failed': 'Agentes que falharam',
  'lac.upd.notes': 'Notas',
  'lac.upd.stage': 'Etapa',
  'lac.upd.result': 'Resultado',
  'lac.upd.os': 'Sistema',
  'lac.upd.targeted': 'No alvo',
  'lac.upd.updated': 'Atualizados',
  'lac.users.status.active.one': '{count} pessoa ativa',
  'lac.users.status.active.other': '{count} pessoas ativas',
  'lac.users.status.pending.one': '{count} aguardando acesso',
  'lac.users.status.pending.other': '{count} aguardando acesso',
  'lac.users.status.invited.one': '{count} convite não aceito',
  'lac.users.status.invited.other': '{count} convites não aceitos',
  'lac.users.status.what': 'pessoas',
  'lac.users.cmd.pending': 'Ver quem aguarda acesso',
  'lac.users.cmd.newProfile': 'Criar um perfil de acesso',
  'lac.users.kpi.all': 'Pessoas',
  'lac.users.col.name': 'Nome',
  'lac.users.col.email': 'E-mail',
  'lac.users.resentMany.one': 'Convite reenviado a {count} pessoa',
  'lac.users.resentMany.other': 'Convite reenviado a {count} pessoas',
  'lac.users.resendCount.one': 'Reenviar convite ({count})',
  'lac.users.resendCount.other': 'Reenviar convites ({count})',
  'lac.help.status.articles.one': '{count} artigo no manual',
  'lac.help.status.articles.other': '{count} artigos no manual',
  'lac.help.cmd.pdf': 'Baixar o manual (PDF)',
  'lac.help.cmd.search': 'Procurar no manual',
  'lac.help.cmd.searchWord': 'manual',
  'lac.help.cmd.searchHint': 'manual <palavras>',
  'lac.help.cmd.searchOne': 'Procurar "{q}" no manual',
  'lac.yes': 'Sim',
  'lac.no': 'Não',
  'lac.ch.status.one': '{count} mudança em {days} dias',
  'lac.ch.status.other': '{count} mudanças em {days} dias',
  'lac.ch.what': 'histórico',
  'lac.ch.cmd.week': 'Mudanças de configuração dos últimos 7 dias',
  'lac.ch.cmd.year': 'Mudanças de configuração do último ano',
  'lac.ch.col.when': 'Quando',
  'lac.ch.col.name': 'Item',
  'lac.ch.col.what': 'O que houve',
  'lac.ch.col.author': 'Quem',
  'lac.ch.col.version': 'Versão',
  'lac.ch.view.timeline': 'Linha do tempo',
  'lac.tpl.status.one': '{count} modelo · {available} disponíveis',
  'lac.tpl.status.other': '{count} modelos · {available} disponíveis',
  'lac.tpl.cmd.use': 'Usar um modelo',
  'lac.tpl.cmd.useWord': 'modelo',
  'lac.tpl.cmd.useHint': 'modelo <nome>',
  'lac.tpl.cmd.useOne': 'Usar o modelo "{name}"',
  'lac.tpl.col.title': 'Modelo',
  'lac.tpl.col.kind': 'Tipo',
  'lac.tpl.col.description': 'Descrição',
  'lac.tpl.col.available': 'Disponível',
  'lac.org.status.locations.one': '{count} local cadastrado',
  'lac.org.status.locations.other': '{count} locais cadastrados',
  'lac.org.status.departments.one': '{count} departamento cadastrado',
  'lac.org.status.departments.other': '{count} departamentos cadastrados',
  'lac.org.cmd.map': 'Ver a estrutura como mapa',
  'lac.org.col.path': 'Caminho',
  'lac.org.col.code': 'Código',
  'lac.org.col.direct': 'Máquinas direto aqui',
  'lac.ai.status.recs.one': '{count} recomendação',
  'lac.ai.status.recs.other': '{count} recomendações',
  'lac.ai.status.critical.one': '{count} crítica',
  'lac.ai.status.critical.other': '{count} críticas',
  'lac.ai.status.lastRun': 'última análise',
  'lac.ai.status.what': 'recomendações',
  'lac.ai.cmd.run': 'Rodar a análise agora ({kind})',
  'lac.ai.cmd.ask': 'Perguntar à IA',
  'lac.ai.col.title': 'Recomendação',
  'lac.ai.col.deadline': 'Prazo',
  'lac.ai.col.reason': 'Motivo',
  'lac.ai.col.actor': 'Quem rodou',
  'lac.ai.col.candidates': 'Candidatas',
  'lac.aut.action': 'O que faz',
  'lac.aut.action.ticket': 'Abre chamado',
  'lac.aut.action.notify': 'Manda aviso',
  'lac.aut.on': 'Ligadas',
  'lac.aut.off': 'Desligadas',
  'lac.aut.kpi.rules': 'Regras',
  'lac.aut.kpi.opened': 'Chamados abertos (24 h)',
  'lac.aut.kpi.notified': 'Avisos enviados (24 h)',
  'lac.aut.status.one': '{count} de {total} regra ligada',
  'lac.aut.status.other': '{count} de {total} regras ligadas',
  'lac.aut.what': 'última execução',
  'lac.aut.cmd.history': 'Abrir o histórico da automação',
  'lac.aut.turnOn': 'Ligar',
  'lac.aut.turnOff': 'Desligar',
  'lac.aut.col.maxHour': 'Limite por hora',
  'lac.aut.col.maxDay': 'Limite por dia',
  'lac.cred.kind': 'Tipo',
  'lac.cred.test': 'Último teste',
  'lac.cred.kpi.all': 'Credenciais',
  'lac.cred.status.one': '{count} credencial no cofre',
  'lac.cred.status.other': '{count} credenciais no cofre',
  'lac.cred.statusFail.one': '{count} falhou no último teste',
  'lac.cred.statusFail.other': '{count} falharam no último teste',
  'lac.cred.col.name': 'Nome',
  'lac.cred.col.user': 'Usuário',
  'lac.cred.col.port': 'Porta',
  'lac.cred.col.scope': 'Onde vale',
  'lac.cred.col.scans': 'Varreduras',
  'lac.cred.col.testedAt': 'Testada em',
  'lac.me.status.mfaOn': 'segundo fator ligado',
  'lac.me.status.mfaOff': 'segundo fator desligado',
  'lac.me.status.sessions.one': '{count} sessão aberta',
  'lac.me.status.sessions.other': '{count} sessões abertas',
};

const es: Record<K, string> = {
  'lac.filters': 'Filtros',
  'lac.kpis': 'Indicadores',
  'lac.view': 'Vista',
  'lac.view.cards': 'Tarjetas',
  'lac.view.table': 'Lista',
  'lac.quick': 'Filtros rápidos',
  'lac.all': 'Todos',

  'lac.integ.kpi.total': 'En el catálogo',
  'lac.integ.kpi.connected': 'Conectadas',
  'lac.integ.kpi.attention': 'Requieren atención',
  'lac.integ.kpi.error': 'Con error',
  'lac.integ.kpi.available': 'Disponibles para conectar',
  'lac.integ.col.name': 'Integración',
  'lac.integ.col.connection': 'Conexión',
  'lac.integ.col.lastSync': 'Última sincronización',
  'lac.integ.status.inUse.one': '{count} integración en uso',
  'lac.integ.status.inUse.other': '{count} integraciones en uso',
  'lac.integ.status.problems.one': '{count} conexión con problema',
  'lac.integ.status.problems.other': '{count} conexiones con problema',
  'lac.integ.status.healthy': 'conexiones sanas',
  'lac.integ.status.sync': 'última sincronización',
  'lac.integ.status.what': 'conexiones',
  'lac.integ.cmd.health': 'Abrir la salud de las conexiones',
  'lac.integ.cmd.connect': 'Conectar una integración',
  'lac.integ.cmd.connectWord': 'conectar',
  'lac.integ.cmd.connectHint': 'conectar <integración>',
  'lac.integ.cmd.connectOne': 'Conectar {name}',
  'lac.integ.cmd.openOne': 'Abrir la conexión {name}',
  'lac.integ.cmd.apiDocs': 'Abrir la documentación de la API',
  'lac.noMatch': 'Nada coincide con estos filtros.',
  'lac.secc.kind': 'Tipo',
  'lac.secc.category': 'Categoría',
  'lac.secc.kpi.total': 'Conectores',
  'lac.secc.kpi.ok': 'Leídos sin error',
  'lac.secc.kpi.running': 'Leyendo ahora',
  'lac.secc.kpi.error': 'Con error',
  'lac.secc.kpi.findings': 'Hallazgos leídos',
  'lac.secc.col.assets': 'Activos',
  'lac.secc.col.error': 'Último error',
  'lac.secc.status.count.one': '{count} conector de seguridad',
  'lac.secc.status.count.other': '{count} conectores de seguridad',
  'lac.secc.status.errors.one': '{count} con error',
  'lac.secc.status.errors.other': '{count} con error',
  'lac.secc.status.running.one': '{count} leyendo ahora',
  'lac.secc.status.running.other': '{count} leyendo ahora',
  'lac.secc.status.what': 'última lectura',
  'lac.secc.cmd.findings': 'Abrir los hallazgos unidos',
  'lac.clearFilters': 'Limpiar filtros',
  'lac.agents.status.updateFailed.one': '{count} agente con actualización fallida',
  'lac.agents.status.updateFailed.other': '{count} agentes con actualización fallida',
  'lac.agents.status.what': 'agentes',
  'lac.agents.cmd.updates': 'Abrir actualizaciones y anillos de los agentes',
  'lac.agents.cmd.find': 'Buscar un agente',
  'lac.agents.cmd.findWord': 'agente',
  'lac.agents.cmd.findHint': 'agente <nombre de la máquina>',
  'lac.agents.cmd.findOne': 'Buscar el agente "{name}"',
  'lac.agents.kpi.lateOffline': 'Atrasados o apagados',
  'lac.agents.kpi.updateFailed': 'Actualización fallida',
  'lac.agents.facet.reason': 'Motivo del fallo de actualización',
  'lac.agents.col.lastError': 'Último error',
  'lac.agents.chip.all': 'Todos',
  'lac.agents.chip.problems': 'Con problema',
  'lac.agents.chip.updateFailed': 'Actualización fallida',
  'lac.agents.chip.collectors': 'Colectores',
  'lac.agents.chip.quarantined': 'En cuarentena',
  'lac.agents.revokeMany.one': '¿Revocar {count} agente?',
  'lac.agents.revokeMany.other': '¿Revocar {count} agentes?',
  'lac.agents.revokedMany.one': '{count} agente revocado',
  'lac.agents.revokedMany.other': '{count} agentes revocados',
  'lac.agents.retriedMany.one': 'Se reintentará la actualización en {count} agente',
  'lac.agents.retriedMany.other': 'Se reintentará la actualización en {count} agentes',
  'lac.agents.retryCount.one': 'Reintentar la actualización ({count})',
  'lac.agents.retryCount.other': 'Reintentar la actualización ({count})',
  'lac.agents.revokeCount.one': 'Revocar ({count})',
  'lac.agents.revokeCount.other': 'Revocar ({count})',
  'lac.upd.kpi.active': 'Distribuciones en curso',
  'lac.upd.kpi.failed': 'Agentes que fallaron',
  'lac.upd.notes': 'Notas',
  'lac.upd.stage': 'Etapa',
  'lac.upd.result': 'Resultado',
  'lac.upd.os': 'Sistema',
  'lac.upd.targeted': 'Objetivo',
  'lac.upd.updated': 'Actualizados',
  'lac.users.status.active.one': '{count} persona activa',
  'lac.users.status.active.other': '{count} personas activas',
  'lac.users.status.pending.one': '{count} esperando acceso',
  'lac.users.status.pending.other': '{count} esperando acceso',
  'lac.users.status.invited.one': '{count} invitación no aceptada',
  'lac.users.status.invited.other': '{count} invitaciones no aceptadas',
  'lac.users.status.what': 'personas',
  'lac.users.cmd.pending': 'Ver quién espera acceso',
  'lac.users.cmd.newProfile': 'Crear un perfil de acceso',
  'lac.users.kpi.all': 'Personas',
  'lac.users.col.name': 'Nombre',
  'lac.users.col.email': 'Correo',
  'lac.users.resentMany.one': 'Invitación reenviada a {count} persona',
  'lac.users.resentMany.other': 'Invitación reenviada a {count} personas',
  'lac.users.resendCount.one': 'Reenviar invitación ({count})',
  'lac.users.resendCount.other': 'Reenviar invitaciones ({count})',
  'lac.help.status.articles.one': '{count} artículo en el manual',
  'lac.help.status.articles.other': '{count} artículos en el manual',
  'lac.help.cmd.pdf': 'Descargar el manual (PDF)',
  'lac.help.cmd.search': 'Buscar en el manual',
  'lac.help.cmd.searchWord': 'manual',
  'lac.help.cmd.searchHint': 'manual <palabras>',
  'lac.help.cmd.searchOne': 'Buscar "{q}" en el manual',
  'lac.yes': 'Sí',
  'lac.no': 'No',
  'lac.ch.status.one': '{count} cambio en {days} días',
  'lac.ch.status.other': '{count} cambios en {days} días',
  'lac.ch.what': 'historial',
  'lac.ch.cmd.week': 'Cambios de configuración de los últimos 7 días',
  'lac.ch.cmd.year': 'Cambios de configuración del último año',
  'lac.ch.col.when': 'Cuándo',
  'lac.ch.col.name': 'Elemento',
  'lac.ch.col.what': 'Qué pasó',
  'lac.ch.col.author': 'Quién',
  'lac.ch.col.version': 'Versión',
  'lac.ch.view.timeline': 'Línea de tiempo',
  'lac.tpl.status.one': '{count} plantilla · {available} disponibles',
  'lac.tpl.status.other': '{count} plantillas · {available} disponibles',
  'lac.tpl.cmd.use': 'Usar una plantilla',
  'lac.tpl.cmd.useWord': 'plantilla',
  'lac.tpl.cmd.useHint': 'plantilla <nombre>',
  'lac.tpl.cmd.useOne': 'Usar la plantilla "{name}"',
  'lac.tpl.col.title': 'Plantilla',
  'lac.tpl.col.kind': 'Tipo',
  'lac.tpl.col.description': 'Descripción',
  'lac.tpl.col.available': 'Disponible',
  'lac.org.status.locations.one': '{count} lugar registrado',
  'lac.org.status.locations.other': '{count} lugares registrados',
  'lac.org.status.departments.one': '{count} departamento registrado',
  'lac.org.status.departments.other': '{count} departamentos registrados',
  'lac.org.cmd.map': 'Ver la estructura como mapa',
  'lac.org.col.path': 'Ruta',
  'lac.org.col.code': 'Código',
  'lac.org.col.direct': 'Máquinas directamente aquí',
  'lac.ai.status.recs.one': '{count} recomendación',
  'lac.ai.status.recs.other': '{count} recomendaciones',
  'lac.ai.status.critical.one': '{count} crítica',
  'lac.ai.status.critical.other': '{count} críticas',
  'lac.ai.status.lastRun': 'último análisis',
  'lac.ai.status.what': 'recomendaciones',
  'lac.ai.cmd.run': 'Ejecutar el análisis ahora ({kind})',
  'lac.ai.cmd.ask': 'Preguntar a la IA',
  'lac.ai.col.title': 'Recomendación',
  'lac.ai.col.deadline': 'Plazo',
  'lac.ai.col.reason': 'Motivo',
  'lac.ai.col.actor': 'Quién lo ejecutó',
  'lac.ai.col.candidates': 'Candidatas',
  'lac.aut.action': 'Qué hace',
  'lac.aut.action.ticket': 'Abre ticket',
  'lac.aut.action.notify': 'Envía aviso',
  'lac.aut.on': 'Activadas',
  'lac.aut.off': 'Desactivadas',
  'lac.aut.kpi.rules': 'Reglas',
  'lac.aut.kpi.opened': 'Tickets abiertos (24 h)',
  'lac.aut.kpi.notified': 'Avisos enviados (24 h)',
  'lac.aut.status.one': '{count} de {total} regla activada',
  'lac.aut.status.other': '{count} de {total} reglas activadas',
  'lac.aut.what': 'última ejecución',
  'lac.aut.cmd.history': 'Abrir el historial de la automatización',
  'lac.aut.turnOn': 'Activar',
  'lac.aut.turnOff': 'Desactivar',
  'lac.aut.col.maxHour': 'Límite por hora',
  'lac.aut.col.maxDay': 'Límite por día',
  'lac.cred.kind': 'Tipo',
  'lac.cred.test': 'Última prueba',
  'lac.cred.kpi.all': 'Credenciales',
  'lac.cred.status.one': '{count} credencial en el cofre',
  'lac.cred.status.other': '{count} credenciales en el cofre',
  'lac.cred.statusFail.one': '{count} falló en la última prueba',
  'lac.cred.statusFail.other': '{count} fallaron en la última prueba',
  'lac.cred.col.name': 'Nombre',
  'lac.cred.col.user': 'Usuario',
  'lac.cred.col.port': 'Puerto',
  'lac.cred.col.scope': 'Dónde vale',
  'lac.cred.col.scans': 'Escaneos',
  'lac.cred.col.testedAt': 'Probada el',
  'lac.me.status.mfaOn': 'segundo factor activado',
  'lac.me.status.mfaOff': 'segundo factor desactivado',
  'lac.me.status.sessions.one': '{count} sesión abierta',
  'lac.me.status.sessions.other': '{count} sesiones abiertas',
};

export const layoutAcMessages = { en, 'pt-BR': ptBR, es } as const;
